import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

export default function HilfeFotodokumentationArtenschutz () {

  const [value, setValue] = React.useState('allgemein');

  const handleChange = (event, newValue) => {
      setValue(newValue);
    
  };

  return(
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList 
            onChange={handleChange} 
            aria-label="Hilfe zur Fotodokumentation"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab value="allgemein" label="Allgemeine Kennzeichnungsmöglichkeiten für Tiere" />
            <Tab value="reptilien" label="Reptilien" />
            <Tab value="schildkroeten" label="Schildkröten" />
            <Tab value="schlangen" label="Schlangen &amp; Echsen" />
            <Tab value="abstaende" label="Abstände der Fotodokumentation" />        
            <Tab value="zu_beachten" label="Was ist beim Fotografieren zu beachten?" />        
          </TabList>
        </Box>

        <TabPanel value="allgemein">
          <h2>
            Allgemeine Kennzeichnungsmöglichkeiten für Tiere
          </h2>
          <p>
            Bei der Fotodokumentation (hauptsächlich für Reptilien seltener auch für Amphibien genutzt) werden die Individualmerkmale in geeigneter Weise dargestellt und bei einigen Arten fortlaufend dokumentiert und aktualisiert, damit eine Zuordnung zur Bescheinigung ermöglicht wird.
          </p>
          <p>
            Nur durch die einwandfrei nachvollziehbare Zuordnung zu einem bestimmten Tier behält die Bescheinigung Ihre Gültigkeit.
          </p>
          <p>
            Die Fotoaufnahmen, von den jeweiligen Merkmalen, sind senkrecht und in der entsprechenden Größe anzufertigen.  Das Merkmal muss gut zu erkennen sein, Fotos auf denen das Merkmal zu klein oder geneigt dargestellt ist sind ungeeignet.
          </p>
          <p>
            Merkmale, die durch Bildaufnahmen zur Identifikation dienen, können dabei z.B. Tattoos, Ohrmarken, alte Verletzungen, Narben oder Brandzeichen/Branding (Brandkennzeichen anzubringen ist seit 1.1.2019 verboten) sein.
          </p>
          <p>
            Gewicht des Tieres sowie das Datum an dem die Aufnahme erstellt wurde sind immer mit anzugeben.
          </p>
        </TabPanel>

        <TabPanel value="reptilien">
            <h2>
              Welche Kennzeichnungsmöglichkeiten gibt es für Reptilien?
            </h2>
            <p>
              Reptilien können mit Transpondern (Mikrochips) gekennzeichnet werden, wenn sie mindestens 200 Gramm (Schlangen) 
              bzw. 500 Gramm (Landschildkröten) wiegen.  
            </p>
            <p>
              Die Dokumentationen von Körpermerkmalen müssen vorhandenen Dokumenten und / oder Erklärungen zugeordnet werden, 
              zusätzlich müssen – soweit möglich - Angaben gemacht werden zur Größe, Gewicht, Geschlecht und Alter und auch zu 
              etwa vorhandenen Besonderheiten der Tiere. Empfohlen wird deshalb die Anfertigung von Tierausweisen mit einer 
              ausführlichen Beschreibung der Tiere und der dazugehörigen Unterlagen (EU-Bescheinigungen, andere Dokumente oder 
              Genehmigungen, Herkunftsangaben, Zuchtbucheinträge).
            </p>
            <p>
              Bei der Anmeldung von Tieren und Beantragung von Bescheinigungen müssen Kennzeichen angegeben und deshalb auch 
              Mehrausfertigungen von Dokumentationen vorgelegt werden.
            </p>
            <p>
              Kennzeichenwechsel sind anzuzeigen und vorhandene Dokumente müssen diesbezüglich ergänzt oder ersetzt werden.
            </p>
        </TabPanel>

        <TabPanel value="schildkroeten">
            <h2>
              Wie werden die Körpermerkmale von Landschildkröten dokumentiert?   
            </h2>
            <p>
              Griechische, Maurische und Ägyptische Landschildkröten, ferner auch Breitrandschildkröten Strahlenschildkröten und Spaltenschildkröten können immer mit Dokumentationen gekennzeichnet werden, da sie gemäß wissenschaftlichen Gutachten bereits in ihrer Körperzeichnung (ähnlich dem menschlichen Fingerabdruck) unveränderliche Merkmale aufweisen. Bei anderen Schildkrötenarten können nur äußerliche Besonderheiten wie Narben oder körperlichen Abnormitäten dokumentiert werden. Gibt es solche nicht, kommt nur die Kennzeichnung mit dem Mikrochip-Transponder in Betracht.
            </p>
            <p>
              Die zur individuellen Erkennung geeigneten körperlichen Merkmale finden sich sowohl auf der Bauch- als auch auf der Rückenseite. Zu ihrer Dokumentation soll mindestens die Bauchseite fotografiert werden. Die Bilder müssen die Anordnung der einzelnen Schilder erkennen lassen, denn die Linien und Kreuzungspunkte, die sich aus der Anordnung der Schilder ergeben, bilden die individuellen Merkmale ab. Bei Strahlenschildkröten genügt die Abbildung des Rückenpanzers, denn hier besteht das Individualmerkmal in der Anordnung der Strahlen.
            </p>

        </TabPanel>

        <TabPanel value="schlangen">
            <h2>
              Wie werden die Körpermerkmale von Riesenschlangen und Eidechsen dokumentiert?
            </h2>
            <p>
              Einige Schlangen- und Eidechsenarten können mit der Fotodokumentation gekennzeichnet werden.
              Von der Südlichen Madagaskar-Boa muss eine Fotografie von der Oberseite des Kopfes angefertigt werden.
              Die Kennzeichnung der Nördlichen Madagaskar-Boa erfordert drei Fotos – von beiden Kopfseiten und der Unterseite des Unterkiefers. Ebenfalls mit drei Fotos wird die Madagaskar-Hundskopf-Boa gekennzeichnet – abzubilden sind hier beide Kopfseiten und der Kopf von oben.
              Die Merkmale von Balearen- und Pityuseneidechsen werden mit einer einzigen Aufnahme vom Kopf und den ersten mindestens fünf Schuppenreihen unterhalb der Kehle dauerhaft dokumentiert.
            </p>
        </TabPanel>

        <TabPanel value="abstaende">
            <h2>
              Wann und in welchen Abständen ist die Fotodokumentation durchzuführen?
            </h2>
            <p>
              Erstmals angelegte Dokumentationen / Tierausweise sind als Mitteilung über die erfolgte Kennzeichnung zu den behördlichen Akten zu reichen, eine Ausfertigung verbleibt beim Tierhalter. Die Dokumentation ist vom jeweiligen Halter in solchen Zeitabständen anzulegen, dass mögliche Änderungen der Körpermerkmale nachvollziehbar sind. Dabei soll das erste Foto einer Jungtierdokumentation erst erfolgen, wenn der Bauchpanzer geschlossen ist. Deshalb wird das erste Foto in der Regel im Herbst des Schlupfjahres gefertigt. Ein weiteres Foto wird im darauf folgenden Frühjahr gemacht. Im selben Jahr soll im Herbst und danach bis zum 10. Lebensjahr jeweils ebenfalls im Herbst ein Foto angefertigt werden. Danach reicht ein Abstand von fünf Jahren, um eventuelle Veränderungen zu dokumentieren.
            </p>
            <p>
              Die turnusmäßig ergänzten Dokumentationen sind den vorhandenen hinzuzufügen und müssen der Naturschutzbehörde nicht zugesandt werden. Auf Aufforderung müssen der Naturschutzbehörde aber alle Dokumentationen eines Tieres vorgelegt werden.
            </p>
            <p>
              Bei der Abgabe eines Tieres sind alle Dokumentationen eines Tieres dem neuen Besitzer auszuhändigen. Versäumte oder fehlerhafte Anschlussdokumentationen können dazu führen, dass Legalitätsnachweise in Frage gestellt werden. Unter Umständen sind dann auch Genehmigungen zur Vermarktung ungültig. Kauf und Verkauf können in solchen Fällen strafrechtlich verfolgt werden.
            </p>
        </TabPanel>

        <TabPanel value="zu_beachten">
            <h2>
              Was ist beim Fotografieren zu beachten?
            </h2>
            <p>
              Wenn die Kennzeichnungspflicht mittels Fotodokumentation erfüllt werden soll, ist eine zeichnerische oder fotografische Darstellung individueller Körpermerkmale vorzunehmen, anhand derer das Tier sich identifizieren lässt. Diese Darstellung ist um eine Beschreibung des Tieres zu ergänzen, die zumindest Angaben zu Größe und Länge, Gewicht, Geschlecht und Alter sowie eine Beschreibung vorhandener Besonderheiten umfasst.
            </p>
            <p>
              Für die Fotos gibt es einige wichtige Kriterien:
            </p>
            <ul>
              <li>die Tiere müssen sauber und trocken sein</li>
              <li>als Hintergrund (Unterlage) sollte Karopapier verwendet werden, damit die Größe der fotografierten Tiere unabhängig vom Maßstab der Bilder erkennbar dargestellt. Eine solches Papier stellt die Kreisverwaltung Recklinghausen als Download zur Verfügung</li>
              <li>die Abbildung der Tiere muss möglichst Bildformat füllend erfolgen und mit möglichst hoher Bildschärfe.</li>
              <li>
                bei der Kennzeichnung von Landschildkröten (ausgenommen: Strahlenschildkröten)  kommt es auf die Darstellung der Linienführungen an, die sich aus der Anordnung der Bauch- und Rückenschilder ergeben:
                <ul>
                  <li>der Bauchpanzer muss deshalb direkt von oben fotografiert werden. Dazu legt man die Schildkröte am besten rücklings auf einen Flaschendeckel oder auf einen Gummiring. Auf dem Bauchpanzerfoto müssen alle Kreuzungen der Bauchschilder scharf und deutlich zu erkennen sein! Jungtiere dürfen deshalb erst fotografiert werden, wenn die Bauchpanzer geschlossen sind.</li>
                  <li>wenn auch der Rückenpanzer fotografiert wird, muss dieser ebenfalls direkt von oben fotografiert werden, so dass das Nackenschild und das fünfte Wirbelschild scharf und deutlich zu erkennen sind.</li>
                  <li>zur vorläufig einfacheren Erkennbarkeit können die Tiere mit Farbmarkierungen (Zeichen oder Nummern) zusätzlich gekennzeichnet werden.</li>
                </ul>
              </li>
              <li>Bilder und Fotodokumentationen, die nicht den Anforderungen genügen (z. B. nicht Format füllende, unscharfe, oder farbstichige Aufnahmen) und die deshalb die Merkmale nicht eindeutig erkennbar abbilden, müssen von den Naturschutzbehörden zurückgewiesen werden</li>
            </ul>

         </TabPanel>

      </TabContext>
    </Box>
  )
}
